import { Form, message, Upload } from "antd";
import React from "react";
import { ReactSVG } from "react-svg";
import { getBase64Promise } from "../../helpers/utils";
const DocumentsUploader = ({
	name,
	multiple,
	documents,
	maxCount,
	setDocuments,
	isRequired,
	isShowUploadList,
	isDisabled,
}) => {
	const handleFailed = (file) =>
		message.error(`${file.name} file upload failed.`);
	const handleRemoved = (file) =>
		message.success(`${file.name} file removed successful`);
	const handleUploaded = (file) =>
		message.success(`${file.name} file uploaded successful.`);
	let counterFile = 0;
	const disable = isDisabled || false;
	const defaultMaxCount = maxCount ? maxCount : 1;

	const filesData = [];
	const handleChangeFile = async (file) => {
		if (file.status === undefined) {
			file.data = await getBase64Promise(file);
			const result = file.data.split("base64,");

			let newFile = {};
			newFile = {
				data: result[1],
				name: file.name,
				type: file.type,
			};
			filesData.push(newFile);
			if (newFile) {
				if (multiple) {
					setTimeout(() => {
						const files = [...documents];
						files.push(...filesData);
						setDocuments(files);
					}, 0);
				} else {
					setDocuments([newFile]);
				}
				handleUploaded(file);
			} else {
				handleFailed(file);
			}
			counterFile = 0;
		}

		if (file.status === "removed") {
			if (multiple) {
				const indexFile = documents.findIndex((f) => f.id === file.id);
				const files = [...documents];
				files.splice(indexFile, 1);

				setDocuments(files);
			} else {
				setDocuments([]);
			}
			handleRemoved(file);
		}

		if (file.status === "error") {
			handleFailed(file);
		}
	};
	const uploadProps = {
		name,
		multiple: !!multiple,
		fileList: documents,
		accept: "image/png, image/jpeg, .pdf, video/*, .docx, .csv",
		beforeUpload: () => {
			++counterFile;
			if (documents.length + counterFile > defaultMaxCount) {
				message.error(`Cannot upload more than ${defaultMaxCount} files`);
				return true;
			}
			return false;
		},
		async onChange({ file }) {
			handleChangeFile(file);
		},
		showUploadList: isShowUploadList && {
			showRemoveIcon: true,
			removeIcon: <ReactSVG src="/icons/delete-all.svg" />,
		},
	};

	return (
		<Form.Item
			name={name}
			className="documents"
			rules={[
				{ required: isRequired, message: "Required" },
				{
					validator: (_, value) => {
						if (
							!isRequired ||
							!value ||
							(value.fileList && value.fileList.length > 0)
						) {
							return Promise.resolve();
						}
						return Promise.reject(new Error("Required"));
					},
				},
			]}
		>
			<Upload.Dragger
				maxCount={defaultMaxCount}
				{...uploadProps}
				disabled={disable}
			>
				<div className="upload-text-section">
					<p className="ant-upload-text">Drag and drop to upload or</p>
					<div className="ant-upload-hint">
						Browse
						{/* <ReactSVG src="/icons/upload.svg" /> */}
					</div>
				</div>
			</Upload.Dragger>
		</Form.Item>
	);
};

export default DocumentsUploader;
